<template>
    <div>
        
        <div v-if="tuto">
            <s-modal 
                :open="tutos==null && tuto.active && tuto.tutoriel==null"
                :close="true"
                @close="closeTuto"
            >
             Avec ce tutoriel tu vas apprendre à utiliser l'application...
             <br/>
             Choisis le tuto que tu souhaites suivre :  
              <br/><br/>
                <div v-for="tutoriel in tutoriels" class="demoTutoriel" v-on:click="choiceTuto(tutoriel)">
                    {{tutoriel.label}}<br/>
                </div>
            </s-modal>
           
            <div v-if="tuto.active && tutos!=null && tuto.tutoriel!=null" >
            <div v-if="tutos">
                <div v-if="tutos[tuto.tuto]" class="g_desktopOn">
                    <div v-if="tutos[tuto.tuto].route==$route.name" class="demo">
                        
                        <div class="entete">
                            {{tuto.tuto+1}} / {{tutos.length}}
                            &nbsp;&nbsp;
                            
                            <div style="float:left" v-if="tuto.tuto!=tutos.length-1">
                               <button v-on:click="terminer"  class="buttonStop">
                                   Arrêter
                               </button>
                           </div>
                            <div style="float:left" v-if="tuto.tuto==tutos.length-1">
                                 <button v-on:click="terminer"  class="buttonStop2">
                                   TERMINE
                               </button>
                            </div>
                        </div>
                        <div>
                        <div class="logoTuto">
                            
                        </div>
                        <div class="ql-editor"  v-html="tutos[tuto.tuto].html" style="text-align:justify">
                        </div>
                        <div style="float:right" v-if="tutos[tuto.tuto].back">
                            <button v-on:click="prec">
                                Revenir
                            </button>
                        </div>
                        
                          <div style="float:left;margin: 10px" v-if="tutos[tuto.tuto].equipe">
                                {{nbEquipes}} /
                                12
                                 <s-button icon="" 
                                    @onclick="suivant" label="Suivant" 
                                    theme="is-success is-small" 
                                    id="next"
                                    v-if="tuto.nbEquipes<12 && tuto.equipeCompleted"
                                    />
                                <s-button icon="" 
                                    @onclick="suivant_suivant" label="OK" 
                                    theme="is-success is-small" 
                                    id="next"
                                    v-if="tuto.nbEquipes==12"
                                    />
                          </div>  
                          <div style="float:left" v-if="tutos[tuto.tuto].score">
                            <s-button @onclick="initScore" theme="is-success" id="reinit" label="Initialiser les scores"/>
                           </div>
                            
                            <div v-if="tuto.badButton" class="badButton">
                                Vous avez cliqué sur un mauvais bouton, merci de suivre le tutoriel
                            </div>
                            
                            </div>
                    </div>
                    
                </div>
                <div v-if="tutos[tuto.tuto]" class="g_mobileOn">
                    <div v-if="tutos[tuto.tuto].route==$route.name" :class="tutos[tuto.tuto].top ? 'demoMobileTop' : 'demoMobile'">
                        
                        
                        <div class="enteteMobile">
                            <div style="float:left">
                                {{tuto.tuto+1}} / {{tutos.length}}
                            </div>
                            <div style="float:right">
                            <div  v-if="tuto.tuto!=tutos.length-1">
                               <button v-on:click="terminer"  class="buttonStop">
                                   Arrêter
                               </button>
                            </div>
                           </div>
                        </div>
                        <div>
                        
                        <div class="ql-editor"  v-html="tutos[tuto.tuto].html" style="text-align:justify">
                        </div>
                        <div style="float:right" v-if="tutos[tuto.tuto].back">
                            <button v-on:click="prec">
                                Revenir
                            </button>
                        </div>
                    
                          <div style="float:left;margin: 10px" v-if="tutos[tuto.tuto].equipe">
                                 {{nbEquipes}} /
                                12
                                 <s-button icon="" 
                                    @onclick="suivant" label="Suivant" 
                                    theme="is-success is-small" 
                                    id="next"
                                    v-if="tuto.nbEquipes<12 && tuto.equipeCompleted"
                                    />
                                <s-button icon="" 
                                    @onclick="suivant_suivant" label="OK" 
                                    theme="is-success is-small" 
                                    id="next"
                                    v-if="tuto.nbEquipes==12"
                                    />
                          </div>  
                          <div style="float:left;margin: 10px" v-if="tutos[tuto.tuto].score">
                            <s-button @onclick="initScore" theme="is-success" id="reinit" label="Initialiser les scores"/>
                           </div>
                            <div style="float:left" v-if="tuto.tuto==tutos.length-1">
                                 <button v-on:click="terminer"  class="buttonStop2">
                                   TERMINER
                               </button>
                            </div>
                            <div v-if="tuto.badButton" class="badButtonMobile">
                                <div style="float:right">
                                    <button class="buttonCloseBad" v-on:click="tuto.badButton=false">
                                        x
                                    </button>
                                </div>
                                Tu as cliqué sur un mauvais bouton, merci de suivre le tutoriel
                            </div>
                            
                            </div>
                            <div style="float:right">
                           
                            &nbsp;&nbsp;
                            <div class="logoTutoMobile">
                            
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            </div>
             
        </div>
      
    </div>
</template>

<style scoped>
.buttonCloseBad {
    border-radius: 20px;
    background-color: red;
    color: white;
}
.demoTutoriel {
    padding: 10px;
    margin-bottom: 10px;
    background-color: rgb(211, 186, 210);
    border-radius: 20px;
}
.demoAccueil {
     position: fixed;
    top: 230px;
    right: 10px;
    background-color: rgba(245, 235, 255, 1);
    border: thin magenta solid;
    border-radius: 20px;
    box-shadow: 10px 10px;
    padding: 10px;
    color: black;
    font-weight: bolder;
    height: 300px;
    width: 500px;
    z-index: 100;
}
.demoTutoriel:hover {
    background-color: rgb(200, 228, 178);
    cursor: pointer;
    border-radius: 20px;
}
.buttonDemo {
    border-radius: 20px;
    background-color: magenta;
    padding-left: 5px;
    padding-right: 5px;
    cursor: pointer;
    color: white;
}
.enteteMobile {
    position: absolute;
    width: 100%;
    top: 3px;
    padding-right: 10px ;
    padding-left: 10px ;
    
}
.buttonStop {
    border-radius: 20px;
    background-color: black;
    padding-left: 5px;
    padding-right: 5px;
    cursor: pointer;
    color: white;
}
.buttonStop2 {
    border-radius: 20px;
    background-color: rgb(53, 129, 9);
    padding-left: 15px;
    padding-right: 15px;
    cursor: pointer;
    color: white;
    font-size: 15px;
}
.buttonDemoBig {
    border-radius: 20px;
    background-color: magenta;
    padding-left: 15px;
    padding-right: 15px;
    cursor: pointer;
    color: white;
    font-size: 23px;
}
.entete {
    width: 100%;
    text-align:right;
    height: 30px;
}
.tuto {
    padding-top: auto;
    padding-bottom: auto;
}
.logoTuto {
  background-image: url("../assets/teacher.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    position: absolute;
    bottom: 0px;
    right: 10px;
    height:90px;
    width: 100px;
    
}
.logoTutoMobile {
 background-image: url("../assets/teacher.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    position: absolute;
    bottom: 0px;
    right: 10px;
    height:50px;
    width: 60px;
    
}
.demo {
    position: fixed;
    top: 230px;
    right: 10px;
    background-color: rgba(245, 235, 255, 0.87);
    border: thin magenta solid;
    border-radius: 20px;
    box-shadow: 10px 10px;
    padding: 10px;
    color: black;
    font-weight: bolder;
    height: 300px;
    z-index: 100;
}
.demoMobile {
    position: fixed;
    max-height: 300px;
    width: 95%;
    right: 10px;
    bottom: 130px;
    margin-right: 10x;
    background-color: rgba(245, 235, 255, 0.95);
    border: thin magenta solid;
    border-radius: 20px;
    box-shadow: 10px 10px;
    color: black;
    font-size: 14px;
    overflow-y: auto;
    padding-top: 15px;
    z-index: 100;
    
}
.demoMobileTop {
    position: fixed;
    max-height: 300px;
    width: 95%;
    right: 10px;
    top: 30px;
    margin-right: 10x;
    background-color: rgba(245, 235, 255, 0.95);
    border: thin magenta solid;
    border-radius: 20px;
    box-shadow: 10px 10px;
    color: black;
    font-size: 14px;
    overflow-y: auto;
    padding-top: 15px;
    z-index: 100;
    
}
.badButton {
    position: fixed;
    bottom: 60px;
    left: 10px;
    background-color: white;
    border: thin red solid;
    border-radius: 20px;
    box-shadow: 10px 10px;
    padding: 10px;
    color: black;
    font-size: 20;
    color: red;
    width: 400px;
}
.badButtonMobile {
    position: fixed;
    bottom: 90px;
    left: 10px;
    background-color: white;
    border: thin red solid;
    border-radius: 20px;
    box-shadow: 10px 10px;
    padding: 10px;
    color: black;
    font-size: 20;
    color: red;
    width: 250px;
}
</style>
<script>
import tuto_api from '@/firebase/tuto_api'
import firebase_api from '@/firebase/firebase_api'
import club_fct from '@/firebase/club'
export default {
    props: {
        open: {
            type: Boolean,
            default: false
        }},
    data() {
        return {
            modalConfirmReinit: false,
            tutoriels: []
        }
    },
    mounted() {
        this.refreshTuto();
    },
    watch: {
        tutoActive(val){
           
            if (val) {
                this.tutoriels = [];
                this.refreshTuto();
            }
            
        },
        nbEquipes(val) {
            if (this.tutos[this.tuto.tuto].equipe && val==12)
                this.suivant_suivant();
        }
    },
    computed: {
        tutoActive:{
            get() {
                return this.$store.getters.getDemo.active;
        }},
        tuto: {
            get() {
                return this.$store.getters.getDemo;
            }
        },
        tutos: {
            get() {
                if (this.$store.getters.getTutos!=null)
                    return this.$store.getters.getTutos.data;
                else
                    return null;
            }
        },
        nbEquipes: {
            get() {
                return this.tuto.nbEquipes
            }
        }
    },
    methods: {
        closeTuto() {
            
            this.$store.dispatch("setDemo", {demo: false});
        },
        async choiceTuto(tutoriel) {
            this.$store.dispatch("setTutoriel", {tutoriel: tutoriel.id});
            if (this.$store.getters.getUser!=null) {
                var idClub = await club_fct.object.createClubDemo(this.$store.getters.getUser, tutoriel.idClubCopy);
                var params = {
                    idClub: idClub,
                    idTournoi: null,
                    idPartie: null
                }
                this.$store.dispatch("setTutoSaveConcours", params);

                this.$router.push({name: "viewClub", params: {id: idClub}});
            }
            else
                this.terminer();
        },
        async terminer() {
            this.$store.dispatch("setTuto", {tuto: 0});
            this.$store.dispatch("setDemo", {demo: false});
            var idClub = this.$store.getters.getDemo.idClub;
            if (idClub!=null) {
                firebase_api.api.getDb().collection("club").doc(idClub).delete().then(result=>{
                    
                });
            }
            /*
            let yesterday = new Date(new Date().setDate(new Date().getDate()-1));
            var todayTime = yesterday.getTime();
           
            var clubDemos = 
                await firebase_api.api.getDb().collection("club")
                    .where("demo", "==", true)
                    .where ("create","<", todayTime)
                    .get();
            
            for (var demo in clubDemos.docs) {
                console.log(clubDemos.docs[demo].id);
                var demoRef = clubDemos.docs[demo].ref;
                await demoRef.delete();
            }*/
            //8Gy1al9Y15C53iTYv9Py
            if (this.$store.getters.getUser.email == "anonyme@petanque-app.com")
               window.location.href = window.location.origin;
            else
                window.location.href = window.location.origin + "/MesClubs";
        }
        ,
        initScore() {
            var idClub = this.tuto.idClub;
            var idTournoi = this.tuto.idTournoi;
            var idPartie = this.tuto.idPartie;
            tuto_api.object.initScore(idClub, idTournoi, idPartie, ()=>{
                
            })
            
        },
        suivant_suivant() {
            var tuto = parseInt(this.$store.getters.getDemo.tuto);
            tuto = tuto=tuto+2;
            this.$store.dispatch("setTuto", {tuto: tuto});
        },
        suivant() {
            var tuto = parseInt(this.$store.getters.getDemo.tuto);
            tuto = tuto++;
            this.$store.dispatch("setTuto", {tuto: tuto});
        },
        prec() {
            var tuto = this.$store.getters.getDemo.tuto;
            if (tuto>0)
                tuto = this.tutos[this.tuto.tuto].returnTo;
            this.$store.dispatch("setTuto", {tuto: tuto});
        },
        reinit() {
            this.modalConfirmReinit = false;
            this.$store.dispatch("setTuto", {tuto: 0});
            window.location.href = window.location.origin + "/club/"+this.$route.params.id;
            
        },
        refreshTuto() {
            firebase_api.api.getDb().collection("tuto").get().then(docTutos=>{
                docTutos.docs.forEach(element => {
                    var dataElement = element.data();
                    dataElement.id = element.id;
                    this.tutoriels.push(dataElement);
                    
                });
            })
        }
    }
}
</script>